const tabList = (theme) => ({
  tabListContainer: {},
  detailContainer: {
    padding: 9,
  },
  tabBar: {
    boxShadow:
      "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
  },
  tabs: {},
  swipeView: {
    background: "white",
  },
  profieImg: {
    width: "100%",
    objectFit: "cover",

    padding: 9,
    boxSizing: "border-box",
    borderRadius: 3,
    overflow: "hidden",
    [theme.breakpoints.down("xs")]: {
      height: 320,
    },
    [theme.breakpoints.up("sm")]: {
      height: 375,
    },
  },
  tabPanel: {
    padding: 24,
    overflow: "scroll",
    color: "black",
    [theme.breakpoints.down("xs")]: {
      height: 333,
    },
    [theme.breakpoints.up("sm")]: {
      height: 262,
    },
  },
});
export default tabList;
